module.exports = __webpack_public_path__ + "img/contrast-03.21530eff.svg";